{
  "appName": "Mock Form Patterns",
  "entryFile": "./app-entry.jsx",
  "entryName": "mock-form-patterns-v3",
  "rootUrl": "/mock-form-patterns",
  "productId": "46a3411a-7a98-4527-bcd8-b0cd71226bff"
}
